import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="bg-gray-100 min-h-screen py-12 px-4 sm:px-6 lg:px-8 font-[poppins]">
      <div className="max-w-4xl mx-auto bg-white shadow-lg rounded-lg p-8">
       <div className="flex justify-center items-center flex-col mb-4">
        <h1 className="text-3xl font-bold font-[poppins] text-gray-900 ">Privacy 
          <span className="font-[Playfair] ml-1 italic text-[#9bd66c]">
        
        Policy
              </span>
            
        </h1>
              <div className=" w-10 h-1 bg-[#9bd66c] my-6 sm:mb-6 sm:mt-0"></div>
       </div>
        <p className="text-gray-600 mb-2">Last updated: June 22, 2025</p>
        <p className="text-gray-700 mb-6">
          This Privacy Policy describes Our policies and procedures on the collection, use, and disclosure of Your information when You use the Service and tells You about Your privacy rights and how the law protects You.
        </p>
        <p className="text-gray-700 mb-6">
          We use Your Personal data to provide and improve the Service. By using the Service, You agree to the collection and use of information in accordance with this Privacy Policy.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4 font-[poppins]">Interpretation and Definitions</h2>
        <h3 className="text-xl font-medium text-gray-700 mt-6 mb-2">Interpretation</h3>
        <p className="text-gray-700 mb-4">
          The words of which the initial letter is capitalized have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or in plural.
        </p>
        <h3 className="text-xl font-medium text-gray-700 mt-6 mb-2">Definitions</h3>
        <p className="text-gray-700 mb-4">For the purposes of this Privacy Policy:</p>
        <ul className="list-disc pl-6 text-gray-700 mb-6">
          <li className="mb-2">
            <strong>Account</strong> means a unique account created for You to access our Service or parts of our Service.
          </li>
          <li className="mb-2">
            <strong>Affiliate</strong> means an entity that controls, is controlled by or is under common control with a party, where "control" means ownership of 50% or more of the shares, equity interest or other securities entitled to vote for election of directors or other managing authority.
          </li>
          <li className="mb-2">
            <strong>Company</strong> (referred to as either "the Company", "We", "Us" or "Our" in this Agreement) refers to Oethical Technology, D2/258, Narmadapuram Rd, opposite Aashima Mall, Danish Nagar, Bagmugaliya, Bhopal, Madhya Pradesh 462026.
          </li>
          <li className="mb-2">
            <strong>Cookies</strong> are small files that are placed on Your computer, mobile device or any other device by a website, containing the details of Your browsing history on that website among its many uses.
          </li>
          <li className="mb-2">
            <strong>Country</strong> refers to: Madhya Pradesh, India
          </li>
          <li className="mb-2">
            <strong>Device</strong> means any device that can access the Service such as a computer, a cellphone or a digital tablet.
          </li>
          <li className="mb-2">
            <strong>Personal Data</strong> is any information that relates to an identified or identifiable individual.
          </li>
          <li className="mb-2">
            <strong>Service</strong> refers to the Website.
          </li>
          <li className="mb-2">
            <strong>Service Provider</strong> means any natural or legal person who processes the data on behalf of the Company.
          </li>
          <li className="mb-2">
            <strong>Third-party Social Media Service</strong> refers to any website or any social network website through which a User can log in or create an account to use the Service.
          </li>
          <li className="mb-2">
            <strong>Usage Data</strong> refers to data collected automatically, either generated by the use of the Service or from the Service infrastructure itself (for example, the duration of a page visit).
          </li>
          <li className="mb-2">
            <strong>Website</strong> refers to Oethical Technology, accessible from{" "}
            <a href="https://www.oethical.com/" className="text-blue-600 hover:underline">
              https://www.oethical.com/
            </a>
          </li>
          <li className="mb-2">
            <strong>You</strong> means the individual accessing or using the Service, or the company, or other legal entity on behalf of which such individual is accessing or using the Service, as applicable.
          </li>
        </ul>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4 font-[poppins]">Collecting and Using Your Personal Data</h2>
        <h3 className="text-xl font-medium text-gray-700 mt-6 mb-2 ">Types of Data Collected</h3>
        <h4 className="text-lg font-medium text-gray-700 mt-4 mb-2">Personal Data</h4>
        <p className="text-gray-700 mb-4">
          While using Our Service, We may ask You to provide Us with certain personally identifiable information that can be used to contact or identify You. Personally identifiable information may include, but is not limited to:
        </p>
        <ul className="list-disc pl-6 text-gray-700 mb-6">
          <li className="mb-2">Email address</li>
          <li className="mb-2">First name and last name</li>
          <li className="mb-2">Phone number</li>
          <li className="mb-2">Address, State, Province, ZIP/Postal code, City</li>
          <li className="mb-2">Usage Data</li>
        </ul>
        <h4 className="text-lg font-medium text-gray-700 mt-4 mb-2">Usage Data</h4>
        <p className="text-gray-700 mb-4">
          Usage Data is collected automatically when using the Service. It may include information such as Your Device's Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our Service that You visit, the time and date of Your visit, the time spent on those pages, unique device identifiers and other diagnostic data.
        </p>
        <h4 className="text-lg font-medium text-gray-700 mt-4 mb-2">Information from Third-Party Social Media Services</h4>
        <p className="text-gray-700 mb-4">
          The Company allows You to create an account and log in to use the Service through the following Third-party Social Media Services:
        </p>
        <ul className="list-disc pl-6 text-gray-700 mb-6">
          <li>Google</li>
          <li>Facebook</li>
          <li>Instagram</li>
          <li>Twitter</li>
          <li>LinkedIn</li>
        </ul>
        <h4 className="text-lg font-medium text-gray-700 mt-4 mb-2">Tracking Technologies and Cookies</h4>
        <p className="text-gray-700 mb-4">
          We use Cookies and similar tracking technologies to track the activity on Our Service and store certain information. The technologies We use may include:
        </p>
        <ul className="list-disc pl-6 text-gray-700 mb-6">
          <li className="mb-2">
            <strong>Cookies or Browser Cookies.</strong> A cookie is a small file placed on Your Device.
          </li>
          <li className="mb-2">
            <strong>Web Beacons.</strong> Certain sections of our Service and our emails may contain small electronic files known as web beacons.
          </li>
        </ul>
        <p className="text-gray-700 mb-4">
          Cookies can be "Persistent" or "Session" Cookies. Persistent Cookies remain on Your personal computer or mobile device when You go offline, while Session Cookies are deleted as soon as You close Your web browser.
        </p>
        <ul className="list-disc pl-6 text-gray-700 mb-6">
          <li className="mb-2">
            <strong>Necessary / Essential Cookies</strong>
            <p>Type: Session Cookies</p>
            <p>Purpose: These Cookies are essential to provide You with services available through the Website.</p>
          </li>
          <li className="mb-2">
            <strong>Cookies Policy / Notice Acceptance Cookies</strong>
            <p>Type: Persistent Cookies</p>
            <p>Purpose: These Cookies identify if users have accepted the use of cookies on the Website.</p>
          </li>
          <li className="mb-2">
            <strong>Functionality Cookies</strong>
            <p>Type: Persistent Cookies</p>
            <p>Purpose: These Cookies allow us to remember choices You make when You use the Website.</p>
          </li>
        </ul>

        <h3 className="text-xl font-medium text-gray-700 mt-6 mb-2">Use of Your Personal Data</h3>
        <p className="text-gray-700 mb-4">The Company may use Personal Data for the following purposes:</p>
        <ul className="list-disc pl-6 text-gray-700 mb-6">
          <li className="mb-2">To provide and maintain our Service, including to monitor the usage of our Service.</li>
          <li className="mb-2">To manage Your Account.</li>
          <li className="mb-2">For the performance of a contract.</li>
          <li className="mb-2">To contact You.</li>
          <li className="mb-2">To provide You with news, special offers and general information.</li>
          <li className="mb-2">To manage Your requests.</li>
          <li className="mb-2">For business transfers.</li>
          <li className="mb-2">For other purposes, such as data analysis.</li>
        </ul>
        <p className="text-gray-700 mb-4">We may share Your personal information in the following situations:</p>
        <ul className="list-disc pl-6 text-gray-700 mb-6">
          <li className="mb-2">With Service Providers.</li>
          <li className="mb-2">For business transfers.</li>
          <li className="mb-2">With Affiliates.</li>
          <li className="mb-2">With business partners.</li>
          <li className="mb-2">With other users.</li>
          <li className="mb-2">With Your consent.</li>
        </ul>

        <h3 className="text-xl font-medium text-gray-700 mt-6 mb-2">Retention of Your Personal Data</h3>
        <p className="text-gray-700 mb-4">
          The Company will retain Your Personal Data only for as long as is necessary for the purposes set out in this Privacy Policy.
        </p>

        <h3 className="text-xl font-medium text-gray-700 mt-6 mb-2">Transfer of Your Personal Data</h3>
        <p className="text-gray-700 mb-4">
          Your information, including Personal Data, is processed at the Company's operating offices and in any other places where the parties involved in the processing are located.
        </p>

        <h3 className="text-xl font-medium text-gray-700 mt-6 mb-2">Delete Your Personal Data</h3>
        <p className="text-gray-700 mb-4">
          You have the right to delete or request that We assist in deleting the Personal Data that We have collected about You.
        </p>

        <h3 className="text-xl font-medium text-gray-700 mt-6 mb-2">Disclosure of Your Personal Data</h3>
        <h4 className="text-lg font-medium text-gray-700 mt-4 mb-2">Business Transactions</h4>
        <p className="text-gray-700 mb-4">
          If the Company is involved in a merger, acquisition or asset sale, Your Personal Data may be transferred.
        </p>
        <h4 className="text-lg font-medium text-gray-700 mt-4 mb-2">Law Enforcement</h4>
        <p className="text-gray-700 mb-4">
          Under certain circumstances, the Company may be required to disclose Your Personal Data if required to do so by law.
        </p>
        <h4 className="text-lg font-medium text-gray-700 mt-4 mb-2">Other Legal Requirements</h4>
        <ul className="list-disc pl-6 text-gray-700 mb-6">
          <li className="mb-2">Comply with a legal obligation</li>
          <li className="mb-2">Protect and defend the rights or property of the Company</li>
          <li className="mb-2">Prevent or investigate possible wrongdoing in connection with the Service</li>
        </ul>

        <h3 className="text-xl font-medium text-gray-700 mt-6 mb-2">Security of Your Personal Data</h3>
        <p className="text-gray-700 mb-4">
          The security of Your Personal Data is important to Us, but remember that no method of transmission over the Internet, or method of electronic storage is 100% secure.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4 font-[poppins]">Children's Privacy</h2>
        <p className="text-gray-700 mb-4">
          Our Service does not address anyone under the age of 13. We do not knowingly collect personally identifiable information from anyone under the age of 13.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4 font-[poppins]">Links to Other Websites</h2>
        <p className="text-gray-700 mb-4">
          Our Service may contain links to other websites that are not operated by Us. We strongly advise You to review the Privacy Policy of every site You visit.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4 font-[poppins]">Changes to this Privacy Policy</h2>
        <p className="text-gray-700 mb-4">
          We may update Our Privacy Policy from time to time. We will notify You of any changes by posting the new Privacy Policy on this page.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4 font-[poppins]">Contact Us</h2>
        <p className="text-gray-700 mb-4">If you have any questions about this Privacy Policy, You can contact us:</p>
        <ul className="list-disc pl-6 text-gray-700 mb-6">
          <li className="mb-2">By email: oethicaltechnology@gmail.com</li>
          <li className="mb-2">
            By visiting this page on our website:{" "}
            <a href="https://www.oethical.com/" className="text-blue-600 hover:underline">
              https://www.oethical.com/
            </a>
          </li>
          <li className="mb-2">By phone number: +1 5589 55488 55</li>
        </ul>
      </div>
    </div>
  );
};

export default PrivacyPolicy;

